import { cn } from '@/lib/utils'
import { brandAssetUrl } from '@/runtime'

/**
 * Credem mark. Renders the supplied SVG at the row's intrinsic height so the
 * logo grows with the surrounding nav as the user scales up text size.
 * The SVG is 128×48; aspect ratio is locked, height fills its parent.
 */
export function BankLogo({ className }: { className?: string }) {
  return (
    <img
      src={brandAssetUrl('credem-lockup.png')}
      alt="Credem"
      className={cn('block h-full w-auto select-none', className)}
      draggable={false}
    />
  )
}
